/**
 * extracts team id from ari
 * the update endpoint expects an id, but we receive an ari when searching for teams
 */
export const extractId = (teamId?: string): string | undefined => teamId?.split('/').pop();
